'use strict';

angular.module('schoolbushubApp')
    .factory('errorHandlerInterceptor', function ($q, $rootScope) {
        return {
            'responseError': function (response) {
                if (!(response.status == 401 && response.data.path && response.data.path.indexOf("/api/account") == 0 )){
	                $rootScope.$emit('schoolbushubApp.httpError', response);
	            }
                return $q.reject(response);
            }
        };
    });
